import script from "./build-duration-percentile-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./build-duration-percentile-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__